import { Filters, SortingMethod } from '@common/types';
import _ from 'lodash';

export const queryKeyFrom = (
  filters: Partial<Filters>,
  currentPage: number,
  sort: SortingMethod,
  isMobileUserAgent: boolean = false,
  partnerId?: string,
  pageSize?: number,
) => {
  // https://tkdodo.eu/blog/effective-react-query-keys#caching-data
  return _.filter(
    [
      isMobileUserAgent ? 'templates-mobile' : 'templates',
      filters,
      currentPage,
      sort,
      partnerId,
      pageSize,
    ],
    (el) => !_.isNil(el),
  );
};
